import React from 'react';
import { useScrollPosition } from '../hooks/useScrollPosition';
import { Button } from './Button';
import { ShoppingCartIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function StickyCartButton() {
  const {
    scrollPosition
  } = useScrollPosition();
  const isVisible = scrollPosition > 800;
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-0 right-0 z-40 px-4 animate-slide-up" data-id="element-288">
      <div className="max-w-4xl mx-auto" data-id="element-289">
        <div className="bg-white rounded-full shadow-2xl p-3 flex items-center justify-between gap-4" data-id="element-290">
          <div className="flex items-center gap-3 pl-4" data-id="element-291">
            <ShoppingCartIcon className="w-6 h-6 text-emerald-600" data-id="element-292" />
            <div className="hidden sm:block" data-id="element-293">
              <p className="font-bold text-navy-900" data-id="element-294">
                Sobrevive a la Quincena + 2 Bonos GRATIS
              </p>
              <p className="text-sm text-gray-600" data-id="element-295">
                Solo <span className="text-emerald-600 font-bold" data-id="element-296">$9.97</span>{' '}
                hoy
              </p>
            </div>
          </div>
          <Button size="md" className="whitespace-nowrap bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600" href={CHECKOUT_URL} data-id="element-297">
            Empezar Ahora 💰
          </Button>
        </div>
      </div>
    </div>;
}